module.exports = __webpack_public_path__ + "static/media/cooking.ad282bb4.svg";